import {Injectable} from '@angular/core';
import {UserContextOption} from 'patja-api';

export interface StoredUserContext {
  role: string;
  companyId?: string | null;
  accountingOfficeId?: string | null;
}

const LAST_CONTEXT_KEY = 'patja_last_context';

@Injectable({
  providedIn: 'root',
})
export class ContextStorageService {
  getStoredContext(): StoredUserContext | null {
    const raw = localStorage.getItem(LAST_CONTEXT_KEY);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as StoredUserContext;
    } catch {
      return null;
    }
  }

  storeContext(context: UserContextOption): void {
    const stored: StoredUserContext = {
      role: context.role,
      companyId: context.companyId ?? null,
      accountingOfficeId: context.accountingOfficeId ?? null,
    };
    localStorage.setItem(LAST_CONTEXT_KEY, JSON.stringify(stored));
  }

  clearStoredContext(): void {
    localStorage.removeItem(LAST_CONTEXT_KEY);
  }

  matchesContext(a: UserContextOption, b: StoredUserContext): boolean {
    return (
      a.role === b.role &&
      (a.companyId ?? null) === (b.companyId ?? null) &&
      (a.accountingOfficeId ?? null) === (b.accountingOfficeId ?? null)
    );
  }
}
